define('app-Search/modules/modules',['./resources', './destination/viewmodel', './hotel/viewmodel', './oceanCruise/viewmodel', './riverCruise/viewmodel', './specialInterest/viewmodel', './tour/viewmodel', './soloTraveller/viewmodel'],
        function (resources, destination, hotel, oceanCruise, riverCruise, specialInterest, tour, soloTraveller) {
            return [
                resources,
                destination,
                hotel,
                oceanCruise,
                riverCruise,
                specialInterest,
                tour,
                soloTraveller
            ];
        });
